import { getDocument } from '@/lib/utils';

const BLOCK_SELECTION_ROOT_ATTR = 'data-block-selection-root';

export function scheduleScrollToPageEditorBlock(blockId: string): void {
  const doc = getDocument();
  const view = doc?.defaultView;
  if (!blockId || !doc || !view) return;

  view.requestAnimationFrame(() => {
    const block = Array.from(
      doc.querySelectorAll<HTMLElement>(`[${BLOCK_SELECTION_ROOT_ATTR}]`),
    ).find((element) => element.getAttribute(BLOCK_SELECTION_ROOT_ATTR) === blockId);

    block?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}
